import React from "react";
import { Link } from "react-router-dom";
import { IUserProduct } from "../../types/userType";

type PhotoSetProps = {
  className: string;
  images?: string[] | Array<IUserProduct>;
  size: string;
  rounded: string;
};

const defaultProps = {
  className: "",
  images: [],
  size: "w-10 h-10",
  rounded: "rounded-full",
};

const ImageSet = ({
  className,
  images,
  size,
  rounded,
}: PhotoSetProps): JSX.Element => {
  return (
    <div className={`relative flex ${className}`}>
      {images?.slice(0, 5).map((image, index) => {
        if (typeof image === "string") {
          return (
            <img
              key={index}
              src={image}
              alt="..."
              className={`border-2 border-blueGray-50 shadow object-cover -ml-4 hover:z-10 hover:scale-125 hover:-translate-y-2 hover:animate-bounce flex-shrink-0 ${size} ${rounded}`}
            ></img>
          );
        } else {
          return (
            <Link
              key={index}
              to={`/product/${image._id}/info`}
              className={`relative border-2 border-blueGray-50 shadow object-contain -ml-4 hover:z-20 hover:scale-125 hover:-translate-y-2 hover:animate-bounce flex-shrink-0 ${size} ${rounded}`}
            >
              <img
                key={index}
                src={image.images[0]}
                alt={image.name || ""}
                className="absolute object-cover w-full h-full rounded-full flex-shrink-0"
              ></img>
            </Link>
          );
        }
      })}
      {images!.length > 5 && (
        <div className="z-10 w-10 h-10 bg-sky-600 rounded-full -ml-4 flex items-center justify-center border-2 bg-opacity-80 border-blueGray-50 hover:z-10 hover:scale-125 hover:-translate-y-2 text-white flex-shrink-0">
          <span>{images!.length - 5}+</span>
        </div>
      )}
    </div>
  );
};

ImageSet.defaultProps = defaultProps;

export default ImageSet;
